import { DatePicker, Form } from 'antd';

import { DatePickerTplType } from '../types/tplTypes';

export const DatePickerTpl = ({ data }: { data: DatePickerTplType }) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const DatePickerRaw: any = DatePicker;
  const {
    placeholder,
    format = 'YYYY-MM-DD',
    picker = 'date',
    allowClear = true,
    componentProps = {},
  } = data;
  if (placeholder) {
    componentProps.placeholder = placeholder;
  }
  return (
    <Form.Item
      name={data.id}
      label={data?.label}
      {...(data.formItemProps || {})}
    >
      <DatePickerRaw
        allowClear={allowClear}
        format={format}
        picker={picker}
        style={{ width: '100%' }}
        {...(data.componentProps || {})}
      />
    </Form.Item>
  );
};
